import { useNavigate } from 'react-router-dom'
import { alpha } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'

import { useAppSelector } from 'src/store/hooks'
import CardSectionHeader from 'src/v3/components/card-section-header'
import { selectEventProgress } from '../events-v2.slice'

type QuizCardProps = {
  eventId: string
  hours: number
  sessionName?: string
  sessionDisplayTime?: string
}

let QuizCard = ({
  eventId,
  hours,
  sessionName,
  sessionDisplayTime,
}: QuizCardProps) => {
  let navigate = useNavigate()
  let quizProgress = useAppSelector(selectEventProgress(eventId))?.quiz
  return (
    <Paper
      className="flex flex-col gap-3 p-6"
      sx={(theme) => ({
        border: `1px solid ${alpha(theme.palette.secondary.main, 0.3)}`,
        borderTop: `3px solid ${theme.palette.secondary.main}`,
      })}
    >
      <CardSectionHeader label="Quiz" />
      {sessionName && sessionDisplayTime && (
        <Box className="flex flex-col gap-1">
          <Typography sx={{ fontWeight: 500 }}>{sessionName}</Typography>
          <Typography variant="body2" color="text.secondary">
            {sessionDisplayTime}
          </Typography>
        </Box>
      )}
      {quizProgress?.kind === 'failed' && (
        <Typography variant="body2" color="text.secondary">
          You did not pass this quiz. You scored {quizProgress.score} correct;{' '}
          {quizProgress.passingScore} correct required to pass.
        </Typography>
      )}
      <Button
        variant="contained"
        color="secondary"
        fullWidth
        onClick={() => navigate(`/events/v2/${eventId}/quiz`)}
      >
        {quizProgress?.kind === 'failed' ? 'Retake quiz' : 'Start quiz'}
      </Button>
      <Typography variant="body2" color="text.secondary">
        Passing this quiz releases your {hours} CE hr{hours === 1 ? '' : 's'}.
      </Typography>
    </Paper>
  )
}

export default QuizCard
